<!--
 * @Description: 入口页
 * @Author: luocheng
 * @Date: 2022-08-27 14:56:13
 * @LastEditors: 姚铃 1871883713@qq.com
 * @LastEditTime: 2023-03-10 11:14:06
-->
<template>
	<div class="webPage">
		<header class="webPage-menu">
			<HeadTabbar :rollColor="rollColor"></HeadTabbar>
		</header>
		<body
			class="webPage-content"
			id="content"
			:class="[showRoll === true ? '' : 'hidden']"
		>
			<router-view class="router-name"></router-view>
		</body>
		<FixTools></FixTools>
	</div>
</template>

<script>
import HeadTabbar from './components/HeadTabbar';
import FixTools from './components/FixTools';
export default {
	components: {
		HeadTabbar,
		FixTools
	},
	props: {},
	data() {
		return {
			// 滚动条长度
			distanceY: null,  
			rollColor: null,
			roll: 0,
			// 定时器
			timer: null, 
			// 滚动条显示隐藏
			showRoll: false 
		};
	},
	watch: {
		/**
		 * @desc: 改变当前路由，滚动条置顶
		 */
		$route() {
			document.getElementById('content').scrollTop = 0;
			this.rollColor = null;
		}
	},
	mounted() {		
		window.addEventListener('scroll', this.scroll, true);
	},
	methods: {
		/**
		 * @desc: 滚动监听事件
		 */
		scroll(event) {
			this.distanceY = event.target.scrollTop;
			let e = event || event.target;
			this.roll = e.srcElement.scrollTop;
			clearTimeout(this.timer);
			this.showRoll = true;
			this.timer = setTimeout(() => {
				if (this.distanceY === this.roll) {
					this.showRoll = false;
				}
			}, 1000);
			if (this.distanceY > 0) {
				this.rollColor = 'white';
			} else {
				this.rollColor = null;
			}
		}
	},
	destroyed() {
		window.removeEventListener('scroll', this.scroll, true);
	}
};
</script>

<style lang="less" scoped>
.hidden::-webkit-scrollbar-thumb {
	background-color: transparent !important;
}
.hidden::-webkit-scrollbar {
	background-color: transparent !important;
}
.webPage {
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
	width: 100%;
	height: 100%;
	background-color: #fff;
	.webPage-menu {
		display: flex;
		overflow-x: hidden;
		width: 100%;
		height: auto;
		background-color: #fff;
	}
	.webPage-content {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: scroll;
		overflow-x: hidden;
		width: 100%;
		height: 500px;
	}
	.webPage-content::-webkit-scrollbar {
		width: 10px;
	}
	.webPage-content::-webkit-scrollbar-track-piece {
		/*鼠标移动上去再显示滚动条*/
		background-color: #fff;
		/* 滚动条的背景颜色 */
		border-radius: 6px;
		/* 滚动条的圆角宽度 */
	}
	.webPage-content::-webkit-scrollbar-thumb {
		background-color: #c0cecc;
	}
	.webPage-content::-webkit-scrollbar-thumb:vertical {
		border: 2px solid #fff;
		background-color: #c0cedc;
		border-radius: 6px;
		outline: 2px solid #fff;
		outline-offset: -2px;
	}
}
.router-name {
	animation: transitionRouterName 0.7s 1;
	animation-fill-mode: forwards;
	transition-duration: 0.3s;
}
@keyframes transitionRouterName {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
<style lang="less">
* {
	// user-select: none;
}
</style>
